import { createTheme } from '@mui/material';

// AloVault brand — mirrors the mobile apps: navy #174E84 (chrome/sidebar),
// brand blue #1B5EA8 (interactive), tile blue #DCEAF8 (pale accents),
// light-gray canvas #F7F7F7. Semantic colors (error/warning/success) are
// status-only and intentionally NOT brand colors.
const theme = createTheme({
    palette: {
        primary: {
            light: '#4E86C6',
            main: '#1B5EA8',
            dark: '#12406F',
        },
        secondary: {
            main: '#174E84',
        },
        darkBackground: {
            main: '#174E84',
        },
        tileBlue: {
            main: '#DCEAF8',
        },
        error: {
            main: '#DA3832',
        },
        warning: {
            main: '#ED6C02',
        },
        success: {
            main: '#55AE58',
        },
        background: {
            default: '#F7F7F7',
        },
    },
    shape: {
        borderRadius: 10,
    },
    typography: {
        fontFamily: '"Montserrat", "Roboto", "Helvetica", "Arial", sans-serif',
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    textTransform: 'initial',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                rounded: {
                    borderRadius: 14,
                },
            },
        },
    },
});

export default theme;
